import { BasicBlock, BLOCK_CATEGORY_TYPE, BlockConfig, DEFAULT_CANVAS_DISPLACEMENT_X } from '@sections/creabots/types/kits'
import getBlocksInfoSchema from '../../../config/getBlocksInfoSchema'

const blocks: BasicBlock[] = [
  {
    id: 0,
    name: 'BHOOT_joystick'
  },
  {
    id: 1,
    name: 'entradas_suelo',
  },
]

export const analogConfig: BlockConfig = {
  blockCategory: 6,
  blockSubCategory: 1,
  canvasDisplacement: { x: DEFAULT_CANVAS_DISPLACEMENT_X, y: 0},
  blocks: getBlocksInfoSchema(blocks, BLOCK_CATEGORY_TYPE.ANALOG),
}